<template>
    <div class="page-content" v-on:keydown.esc="escPressed">
        <div v-show="working > 0" class="lds-facebook"><div></div><div></div><div></div></div>
        <p>
            <input type="checkbox" id="remove-empty" v-model="removeEmpty"><label for="remove-empty">Remove if empty?</label>
            <input type="text" v-model="prefix" placeholder="prefix...">^(.*)$<input v-model="postfix" type="text" placeholder="postfix...">
            <span>\n&nbsp;</span>
            <button v-show="prefix !== '' || postfix !== ''" v-on:click="resetPostPrefix"><x-icon class="red"></x-icon></button>
            <span class="combo">
                <button class="undoredo" v-on:click="unDo" v-bind:disabled="historyIndex <= 0">&#8592;</button>
                <button class="misc" v-bind:disabled="history.length < 2">history</button>
                <button class="undoredo" v-on:click="reDo" v-bind:disabled="(historyIndex === (history.length - 1)) || history.length === 0">&#8594;</button>
            </span>
        </p>
        <div class="safe-txtarea">
            <textarea rows="10" cols="250" autocorrect="off" autocapitalize="off" spellcheck="false" autocomplete="off" v-if="prefix !== '' || postfix !== ''" v-model="alternativeText" name="alternative-text-tools" readonly></textarea>
        </div>
        <div class="safe-txtarea">
            <textarea rows="10" cols="250" autocorrect="off" autocapitalize="off" spellcheck="false" autocomplete="off" v-model="text" name="text-tools" v-bind:readonly="working > 0" v-bind:class="{'working':(working > 0)}"></textarea>
        </div>
        <transition name="server-message">
            <div class="message-div" v-show="lastMessage != ''">
                <textarea v-bind:key="'message-textarea'" class="message">{{lastMessage}}</textarea>
                <x-icon v-bind:key="'message-button'" class="red" v-on:click="lastMessage = ''"></x-icon>
            </div>
        </transition>
        <div>
            <button v-bind:disabled="true">Check URLS</button>
            <button v-bind:disabled="working > 0"  v-on:click="getDomains">Get Domains</button>
            <button v-bind:disabled="working > 0" v-on:click="oneLinkPerDomain">One Link/Domain</button>
            <button v-bind:disabled="working > 0" v-on:click="removeDupes">Remove dupes</button>
            <button v-bind:disabled="working > 0" v-bind:class="{'working':(working_tool === 'add-sites')}" v-on:click="addSites">Add Sites</button>
            <button v-bind:disabled="working > 0" v-bind:class="{'working':(working_tool === 'remove-sites')}" v-on:click="removeSites">Remove Sites</button>
            <button v-bind:disabled="working > 0" v-bind:class="{'working':(working_tool === 'remove-whitelisted')}" v-on:click="removeWhiteListed">Remove Whitelisted</button>
            <!--<span class="combo">-->
                <!--<button class="remove-whitelisted">➕</button>-->
                <!--<button class="misc">Blacklist</button>-->
                <!--<button class="remove-whitelisted">➖</button>-->
            <!--</span>-->
            <button v-bind:disabled="working > 0"  v-on:click="sortStrings">A &#8594; Z</button>
            <button v-bind:disabled="working > 0"  v-on:click="reverseStrings">&#8593; &#8595; Reverse</button>
            <div class="textarea-accessory">
                <span>{{lines.length}} lines / {{text.length}} characters</span>
                <button><file-text-icon></file-text-icon></button>
                <button class="green" v-on:click="addNotes"><file-plus-icon></file-plus-icon></button>
                <button class="red" v-on:click="removeNotes"><file-minus-icon></file-minus-icon></button>
            </div>
        </div>
    </div>
</template>

<script>
    import Storages from 'js-storage'
    import axios from 'axios'
    import qs from 'qs'

    import config from '@/config'

    import CustomEvents from '@/CustomEvents'

    import keydownMixin from '@/keydown.mixin'

    import { XIcon, FileTextIcon, FilePlusIcon, FileMinusIcon} from 'vue-feather-icons'

    export default {
        mixins:[keydownMixin],
        components:{
            XIcon,
            FileTextIcon,
            FilePlusIcon,
            FileMinusIcon,
            CustomEvents
        },
        name: "Home.vue",
        data: function (){
            return {
                saveHistory: true,
                historyIndex: 0,//!!!
                history: [],
                working: 0,
                working_tool: 'nop',
                removeEmpty: '',
                text: '',
                postfix: '',
                prefix: '',
                lines: [],
                lastMessage: ''
            }
        },
        watch:{
            text: function(val){
                console.log("watchme!", this.saveHistory);
                //TODO: limit for iterations count in history
                if (this.saveHistory) {
                    this.history.splice(this.historyIndex + 1);

                    this.history.push(this.text);
                    this.historyIndex = this.history.length - 1;
                }

                this.lines = this.text.split('\n');
                this.saveHistory = true;
                Storages.localStorage.set('Tools:text', this.text);
            },
            removeEmpty: function (val) {
                Storages.localStorage.set('Tools:removeEmpty', this.removeEmpty);
            },
            postfix: function (val) {
                Storages.localStorage.set('Tools:postfix', this.postfix);
            },
            prefix: function (val) {
                Storages.localStorage.set('Tools:prefix', this.prefix);
            }
        },
        computed: {
            alternativeText: function () {
                if (this.prefix === '' & this.postfix === ''){
                    return "";
                }
                let newText = '';
                this.lines.forEach( (value) =>{
                    newText = newText + this.prefix + value + this.postfix + '\n';
                });
                return newText;
            }
        },
        mounted: function(){
            this.removeEmpty = Storages.localStorage.isSet('Tools:removeEmpty')?Storages.localStorage.get('Tools:removeEmpty'):'';
            this.text = Storages.localStorage.isSet('Tools:text')?Storages.localStorage.get('Tools:text'):'';
            this.postfix = Storages.localStorage.isSet('Tools:postfix')?Storages.localStorage.get('Tools:postfix'):'';
            this.prefix = Storages.localStorage.isSet('Tools:prefix')?Storages.localStorage.get('Tools:prefix'):'';
            this.lines = this.text.split('\n');
        },
        methods: {
            escPressed: function (){
                if (this.lastMessage !== ''){
                    this.lastMessage = '';
                    return;
                }

                if (this.postfix !== ''){
                    this.postfix = '';
                }

                if (this.prefix !== ''){
                    this.prefix = '';
                }
            },
            addNotes: function (){
                CustomEvents.$emit("add-note", this.lines);
            },
            removeNotes: function (){
                CustomEvents.$emit("remove-note", this.lines);
            },
            oneLinkPerDomain: function (){
                let domains = [];
                let _links = [];

                console.log(this.text)

                let items = this.text.trim().split('\n');
                items.map(s => s.trim());

                if (this.removeEmpty) {
                    items = items.filter(item => {return item !== ''});
                }

                items.forEach((item) => {
                        let domain = hostname(item);
                        if (domains.indexOf(domain) === -1){
                            domains.push(domain);
                            _links.push(item);
                        }
                    });

                this.text = _links.join('\n');
            },
            removeSites: function (){
                this.working_tool = 'remove-sites';
                this.working++;

                this.lastMessage = '';

                let payload = {items: this.text};

                let request_url = config.api_url + '/?op=sites&cmd=filter';

                axios.post(
                    request_url,
                    qs.stringify(payload),
                    {
                        headers: {
                            "Content-Type": "application/x-www-form-urlencoded"
                        }
                    }
                )
                .then( (response) => {
                    this.text = response.data.text;
                    this.lastMessage = "Removed sites: \n" + response.data.removed;
                })
                .catch((error) => {
                    console.log(error);
                    that.lastMessage = 'Error, see console!';
                })
                .finally( () => {
                    this.working_tool = 'nop';
                    this.working--;
                });
            },
            removeWhiteListed: function (){
                this.working_tool = 'remove-whitelisted'
                this.working++;

                this.lastMessage = '';

                let payload = {items: this.text};

                let request_url = config.api_url + '/?op=whitelist&cmd=filter';

                axios.post(
                    request_url,
                    qs.stringify(payload),
                    {
                        headers: {
                            "Content-Type": "application/x-www-form-urlencoded"
                        }
                    }
                )
                .then( (response) => {
                    this.text = response.data.text;
                    this.lastMessage = "Removed sites: \n" + response.data.removed;
                })
                .catch((error) => {
                    console.log(error);
                })
                .finally( () => {
                    this.working_tool = 'nop';
                    this.working--;
                });
            },
            addSites: function (){
                this.working_tool = 'add-sites';
                this.working++;

                this.lastMessage = '';

                let request_url = config.api_url + '/?op=sites&cmd=get';

                axios.get(
                    request_url
                )
                    .then( (response) => {
                        let tmp = Array();
                        let sites = response.data;
                        sites.forEach((site) => {
                            tmp.push(site.host.trim());
                        });

                        let newText = tmp.join('\n').trim();

                        if (newText.length > 0){
                             if (this.text.trim().length > 0){
                                 this.text = this.text + '\n' + newText;
                             }else{
                                 this.text = newText;
                             }
                        }
                    })
                    .catch((error) => {
                        console.log(error);
                    })
                    .finally( () => {
                        this.working_tool = 'nop';
                        this.working--;
                    });
            },
            resetPostPrefix: function (){
                this.postfix = '';
                this.prefix = '';
            },
            unDo: function (){
                if (this.historyIndex == 0){return}
                this.historyIndex--;
                this.saveHistory = false;
                this.text = this.history[this.historyIndex];
            },
            reDo: function(){
                if (this.historyIndex == (this.history.length - 1)){return}
                this.historyIndex++;
                this.saveHistory = false;
                this.text = this.history[this.historyIndex];
            },
            reverseStrings: function (){
                let items = this.text.split('\n').map(s => s.trim());
                items = items.reverse();

                if (this.removeEmpty) {
                    this.text = items.filter(item => {return item != ''}).join('\n');
                }else{
                    this.text = items.join('\n')
                }
            },
            sortStrings: function () {
                let items = this.text.split('\n').map(s => s.trim());
                items = items.sort();

                if (this.removeEmpty) {
                    this.text = items.filter(item => {return item != ''}).join('\n');
                }else{
                    this.text = items.join('\n')
                }
            },
            removeDupes: function () {
                let items = this.text.split('\n').map(s => s.trim());
                items = uniq(items);
                if (this.removeEmpty) {
                    this.text = items.filter(item => {return item != ''}).join('\n');
                }else{
                    this.text = items.join('\n')
                }
            },
            getDomains: function () {
                let items = this.text.split('\n').map(s => s.trim());

                let domains = [];

                items.forEach((item) => {
                    if (!this.removeEmpty){
                        domains.push(hostname(item));
                    }else if (item !== ''){
                        domains.push(hostname(item));
                    }
                });

                this.text = domains.reverse().join('\n');
            }
        }
    }
</script>

<style scoped>
    .page-content div{
        margin: 0.25rem;
        display: flex;
        flex-direction: row;
        width: 100%;
        align-items: end;
    }

    div.textarea-accessory{
        text-align: right;
        margin: 0;
        align-items: center;
        justify-content: flex-end;
        font-family: monospace;
    }

    .textarea-accessory span{
        margin: 0 0.5rem;
        color: #ffffff;
        text-shadow: -1px 1px 0px #4e1b14;
    }

    .page-content button{
        flex-shrink: 0;
    }

    .page-content button:first-of-type{
        margin-left: 0;
    }

    .page-content button:last-of-type{
        margin-right: 0;
    }

    .page-content button:last-of-type:hover{
        margin-right: 1px;
    }

    .combo{
        display: flex;
        background-color: #CCCCCC;
        color: #ffffff;
        margin: 0 0.5rem;
    }

    .combo button{
        min-width: 2rem;
        margin: 0;
        font-weight: bold;
        font-size: 0.6rem;
    }

    .combo button:first-of-type{
        z-index: 100;
        border-top-right-radius: 0;
        border-bottom-right-radius: 0;
    }

    .combo button:last-of-type{
        z-index: 10;
        border-top-left-radius: 0;
        border-bottom-left-radius: 0;
    }

    .combo button.misc:disabled{
        background: none;
        box-shadow: none;
        color: #555555;
    }

    .combo button.misc{
        color: #ed0028;
        padding: 0.5rem;
        margin: 0;
        background: #bdc3c7;
        /* background: linear-gradient(to top, #ff7a2c, #bdc3c7, #bdc3c7,#bdc3c7, #83a8be); */
        background: -webkit-gradient(linear, left bottom, left top, from(#ff7a2c), to(#ffaf4f));
        background: linear-gradient(to top, #ff7a2c, #ffaf4f);
        box-shadow: inset 0px 0px 5px 2px #d04242;
        border-style: outset;
        border-radius: 0;
        border-right: 0;
        border-bottom: 1px solid #FFF;
        border-left: 0;
        border-top: 1px solid #5a5a5a;
        outline: none;
        transition: 0.5s;
    }

    .working{
        background-image: repeating-linear-gradient(45deg, transparent, transparent 10px, rgba(255, 8, 0, 0.55) 10px, rgba(255, 8, 0, 0.55) 20px);
        background-size: 56px 56px;
        animation: gradient 1s linear infinite;
        animation-fill-mode: forwards;
        text-shadow: none;
        color: rgba(0, 0, 0, 0.5);
        filter: shadow( 1px 1px 1px rgba(1, 1, 0, 1));
        text-decoration: none !important;
    }

    textarea.working{
        text-decoration: none;
        background-image: repeating-linear-gradient(45deg, #dedede, #dedede 90px, #ed213a 90px, #ed213a 180px);
        background-size: 254px 254px;
        -webkit-animation: gradient-textarea 1s linear infinite;
        animation: gradient-textarea 1s linear infinite;
        -webkit-animation-fill-mode: forwards;
        animation-fill-mode: forwards;
        background-color: #dedede;
        color: rgba(0, 0, 0, 0.5);
    }

    @keyframes gradient-textarea{
        0%{background-position:0 50%}
        100%{background-position:254px 50%}
    }

    @keyframes gradient {
        0%{
            background-position:0 50%;
            color: #ffd600;
            text-shadow: 0 0 3px #ffa700;
        }

        50%{
            color: #ff0700;
            text-shadow: 0 0 5px #ff5100;
        }

        100%{
            background-position: 56px 50%;
            color: #ffd600;
            text-shadow: 0 0 3px #ffa700;
        }
    }

    div.lds-facebook{
        right: 6px;
        bottom: 6px;
        top: unset;
    }

    button.working{
        background-color: #CCCCCC;
        background: repeating-linear-gradient(45deg, transparent, transparent 10px, rgba(255, 8, 0, 0.8) 10px, rgba(255, 8, 0, 0.8) 20px), linear-gradient(to bottom, #ffffff, #acacac);
        background-size: 56px 100%;
        animation: gradient 1s linear infinite;
        animation-fill-mode: forwards;
        color: #5a5a5a;
        margin-right: calc(0.5rem + 1px);
        box-shadow: none;
        border-left: 1px solid #EEE;
        border-bottom: 1px solid #FFF;
        border-right: 1px solid #898989;
        border-top: 1px solid #656565;
    }

    .page-content .message {
        display: block;
        width: 100%;
        padding: 0.2rem;
        background-color: #fff7da;
        color: #6b6b6b;
        font-family: monospace;
        text-shadow: 1px 1px 0px #00ff07;
    }

    .message-div{
        max-height: 10rem;
        height: 10rem;
    }

    .message-div textarea{
        height: 100%;
    }

    .server-message-enter-active {
        transition: all .3s ease;
    }
    .server-message-leave-active {
        transition: all .3s ease;
    }

    .server-message-enter-to{
        max-height: 10rem;
    }

    .server-message-enter, .server-message-leave-to{
        max-height: 0;
    }
</style>
